import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckGreenCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 975 1024",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M487.634 85.333c-224.303 0-406.348 191.147-406.348 426.667s182.045 426.667 406.348 426.667c224.305 0 406.352-191.147 406.352-426.667s-182.048-426.667-406.352-426.667zM377.514 695.042l-145.879-153.176c-15.848-16.642-15.848-43.52 0-60.16s41.448-16.64 57.295 0l117.435 122.882 279.569-293.549c15.848-16.64 41.448-16.64 57.295 0s15.848 43.52 0 60.16l-308.42 323.842c-15.441 16.638-41.448 16.638-57.295 0z",
		fill: "rgb(0, 164, 99)"
	})
});
const ForwardRef = forwardRef(SvgCheckGreenCircle);
export default ForwardRef;
